<template>
  <router-view />
</template>

<script setup>
  import { computed, provide } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { hasMobileDevice } from '~/utils/hasMobileDevice';

  const { locale } = useI18n();

  const isMobule = hasMobileDevice();

  const desktopUrl = computed(() => `https://alifshop.uz/${locale.value}?utm_source=juma`);
  const mobileUrl = 'https://alifmobi.page.link/alifshop?id=579b1915-28f0-4b5b-6799-af8654064a83';

  const AlifJumaUrl = computed(() => (isMobule ? mobileUrl : desktopUrl.value));

  provide('alif_juma_url', AlifJumaUrl);
</script>

<style lang="scss"></style>
